module.exports = __webpack_public_path__ + "img/KALUG.deaa4371.png";